import { render } from "./ProjectSettingsTimezone.vue?vue&type=template&id=13f4980e&scoped=true"
import script from "./ProjectSettingsTimezone.vue?vue&type=script&lang=js"
export * from "./ProjectSettingsTimezone.vue?vue&type=script&lang=js"

import "./ProjectSettingsTimezone.vue?vue&type=style&index=0&id=13f4980e&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f4980e"]])

export default __exports__